
<template>
  <div>
    <v-form :readonly="is_readonly" ref="form">
      <template v-if="is_readonly">
        <v-chip v-for="kind in enabledKinds" :key="kind" class="ma-1" small>
          {{ paymentLabel(kind) }}
        </v-chip>
      </template>
      <template v-else>
        <v-checkbox
          v-for="option in paymentOptions"
          :key="option.value"
          v-model="local_model.receipt_config.kinds"
          :label="option.label"
          :value="option.value"
          color="primary"
          hide-details
          class="mt-0"
        ></v-checkbox>
      </template>

      <v-subheader class="px-0">Tipo de frete padrão</v-subheader>
      <v-select
        v-if="is_readonly"
        :value="freightKindLabel(local_model.freight_kind_default)"
        label="Tipo de frete padrão"
        readonly
        prepend-icon="mdi-truck-cargo-container"
      ></v-select>
      <v-select
        v-else
        v-model="local_model.freight_kind_default"
        :items="freightKindOptions"
        label="Tipo de frete padrão"
        prepend-icon="mdi-truck-cargo-container"
        clearable
        hint="Pré-selecionado ao escolher este motorista no pedido"
        persistent-hint
      ></v-select>

      <template v-if="hasKind('pix')">
        <v-radio-group v-model="local_model.receipt_config.pix_key_kind" row @change="() => local_model.receipt_config.pix_key = null">
          <v-radio label="CNPJ" value="cnpj"></v-radio>
          <v-radio label="Email" value="email"></v-radio>
          <v-radio label="Telefone" value="phone"></v-radio>
          <v-radio label="Chave Aleatória" value="random"></v-radio>
        </v-radio-group>
        <v-text-field
          :rules="cnpj" key="text_field_1"
          v-if="local_model.receipt_config.pix_key_kind == 'cnpj'"
          v-model="local_model.receipt_config.pix_key"
          label="Chave PIX" prepend-icon="mdi-key"
          v-mask="'##.###.###/####-##'"
        ></v-text-field>
        <v-text-field
          :rules="emailRules" key="text_field_2"
          v-if="local_model.receipt_config.pix_key_kind == 'email'"
          v-model="local_model.receipt_config.pix_key"
          label="Chave PIX" prepend-icon="mdi-key"
        ></v-text-field>
        <v-text-field
          :rules="required_phone" key="text_field_3"
          v-if="local_model.receipt_config.pix_key_kind == 'phone'"
          v-model="local_model.receipt_config.pix_key"
          label="Chave PIX" prepend-icon="mdi-key"
          v-mask="'(##) ## #####-####'"
        ></v-text-field>
        <v-text-field
          :rules="required" key="text_field_4"
          v-if="local_model.receipt_config.pix_key_kind == 'random'"
          v-model="local_model.receipt_config.pix_key"
          label="Chave PIX" prepend-icon="mdi-key"
        ></v-text-field>
      </template>

      <template v-if="hasKind('deposit')">
        <v-checkbox label="Conta CNPJ" v-model="cnpj_account" color="red" @change="clearDocumentAccount"></v-checkbox>
        <template>
          <v-text-field v-if="!cnpj_account" :rules="required"
            v-model="local_model.accounts[0].CPF" label="CPF Titular" prepend-icon="mdi-badge-account-horizontal-outline"
            v-mask="'###.###.###-##'"
          ></v-text-field>
          <v-text-field v-if="cnpj_account" :rules="cnpj"
            v-model="local_model.accounts[0].CNPJ" label="CNPJ Titular" prepend-icon="mdi-badge-account-horizontal-outline"
            v-mask="'##.###.###/####-##'"
          ></v-text-field>
          <v-text-field
            :rules="required"
            v-model="local_model.accounts[0].name"
            label="Titular" prepend-icon="mdi-account-circle"
          ></v-text-field>
          <v-text-field
            v-if="is_readonly"
            :value="local_model.accounts[0].bank.data.attributes.name"
            label="Banco" readonly
            prepend-icon="mdi-bank"
          ></v-text-field>
          <v-autocomplete
            v-if="!is_readonly"
            v-model="local_model.accounts[0].bank_id"
            :items="allBanks"
            label="Banco"
            prepend-icon="mdi-bank"
            hide-no-data item-text="attributes.name"
            item-value="attributes.id"
            :rules="[v => !!v || 'Banco é necessário']"
          ><v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition></v-autocomplete>
          <v-row>
            <v-col sm='5'>
              <v-text-field
                v-mask="'#####'" :rules="required"
                v-model="local_model.accounts[0].agency"
                label="Agência" prepend-icon="mdi-account-credit-card"
                type="tel"
              ></v-text-field>
            </v-col>
            <v-col sm='4' class="pl-0">
              <v-text-field
                v-model="local_model.accounts[0].digit"
                label="Dígito" v-mask="'##'"
                prepend-icon="mdi-minus" type="tel"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm='5'>
              <v-text-field
                :rules="required" v-model="local_model.accounts[0].number" label="Conta"
                prepend-icon="mdi-account-credit-card" v-mask="'#########'" type="tel"
              ></v-text-field>
            </v-col>
            <v-col sm='4' class="pl-0">
              <v-text-field
                :rules="required" v-model="local_model.accounts[0].account_digit"
                label="Dígito" v-mask="'##'" prepend-icon="mdi-minus" type="tel"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-radio-group v-model="local_model.accounts[0].current_account" row>
            <v-radio color="blue" label="Conta Corrente" :value="true"></v-radio>
            <v-radio color="red" label="Conta Poupança" :value="false"></v-radio>
          </v-radio-group>
        </template>
      </template>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations.js'

const PAYMENT_LABELS = {
  cash: 'Dinheiro',
  deposit: 'Depósito',
  pix: 'Pix',
  bill: 'Boleto',
}

const FREIGHT_KIND_LABELS = {
  cte: 'CT-E',
  mei: 'MEI',
  normal: 'Normal',
}

export default {
  name: 'ReceiptConfigForm',
  mixins: [validations],
  props: {
    is_readonly: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: {}
    },
    creating:{
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      cnpj_account: false,
      paymentOptions: [
        { label: 'Dinheiro', value: 'cash' },
        { label: 'Depósito', value: 'deposit' },
        { label: 'PIX', value: 'pix' },
        { label: 'Boleto', value: 'bill' },
      ],
      freightKindOptions: [
        { text: 'CT-E', value: 'cte' },
        { text: 'MEI', value: 'mei' },
        { text: 'Normal', value: 'normal' },
      ],
      local_model: {
        id: null,
        freight_kind_default: null,
        receipt_config: {
          kind: 'cash',
          kinds: ['cash'],
          pix_key_kind: null,
          pix_key: null,
        },
        accounts: [
          {
            bank: '',
            agency: '',
            account: '',
            titular: '',
            titularCPF: '',
            current_account: false,
          }
        ]
      }
    }
  },
  methods: {
    validate(){
      if (!this.local_model.receipt_config.kinds?.length) {
        return false
      }
      return this.$refs.form.validate()
    },
    paymentLabel(kind) {
      return PAYMENT_LABELS[kind] || kind
    },
    freightKindLabel(value) {
      return FREIGHT_KIND_LABELS[value] || value || '—'
    },
    hasKind(kind) {
      return this.enabledKinds.includes(kind)
    },
    clearDocumentAccount(){
      if(this.cnpj_account){
        this.local_model.accounts[0].CPF = null
      }else{
        this.local_model.accounts[0].CNPJ = null
      }
    },
    setupLocalModel() {
      if(!this.creating){
        let data = this.model.data ? this.model.data : this.model
        const receiptConfig = {...(data.attributes?.receipt_config || {})}
        if (!receiptConfig.kinds?.length && receiptConfig.kind) {
          receiptConfig.kinds = [receiptConfig.kind]
        }
        this.local_model.receipt_config = receiptConfig
        this.local_model.freight_kind_default = data.attributes?.freight_kind_default || null
        if (data.attributes.accounts && data.attributes.accounts.data[0]){

          this.local_model.accounts = [...data.attributes.accounts.data.map(acc => acc.attributes)]
          this.cnpj_account = this.local_model.accounts[0].CNPJ?.length > 3
        }
      }
    },
    ...mapActions({
      getBanks: 'Bank/index'
    })
  },
  mounted () {
    this.setupLocalModel();
    this.getBanks();
  },
  computed: {
    ...mapState({
      allBanks: state => state.Bank.allBanks,
    }),
    enabledKinds() {
      const kinds = this.local_model.receipt_config?.kinds
      if (kinds?.length) return kinds
      const kind = this.local_model.receipt_config?.kind
      return kind ? [kind] : []
    },
  },
}
</script>
